import React, { useEffect } from "react";
import AboutHero from "../components/about/AboutHero";
import OurMission from "../components/about/OurMission";

export default function About() {
  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  return (
    <div>
      <AboutHero />

      <OurMission />
    </div>
  );
}
